import React from 'react'

import { TicketTooltip } from './Styles'
import { ReactComponent as Ticket } from 'assets/images/Ticket.svg'
import { IconContainer, RouteTicketContainer } from './Styles'

interface Props {
  content: string
  n_tickets: React.ReactNode
}

const RouteTicket = ({ content, n_tickets }: Props) => {
  const [show, setShow] = React.useState(false)
  const handleMouseEnter = React.useCallback(() => setShow(true), [])
  const handleMouseLeave = React.useCallback(() => setShow(false), [])

  return (
    <RouteTicketContainer>
      <IconContainer onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <Ticket />
        <p>{n_tickets}</p>
      </IconContainer>
      <TicketTooltip show={show}>{content}</TicketTooltip>
    </RouteTicketContainer>
  )
}

export default React.memo(RouteTicket)
